<template>
  <div @click="hideMe" v-if="!isMobile" class="sm-overlay" :class="{'sm-hidden' : curMode === 'category'}"></div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
name: "sm-overlay",
  computed: {
    ...mapGetters("search", ["mode", "isMobile"]),
    curMode: function () {
      return this.mode;
    },
  },
  methods: {
    ...mapActions("search", ["closeSearch"]),
    hideMe() {
      this.closeSearch()
    },
  }
}
</script>